export default "__VITE_ASSET__31839b7d__"